import { render } from "./RequestNOAnnualLeave.vue?vue&type=template&id=6985f84e"
import script from "./RequestNOAnnualLeave.vue?vue&type=script&lang=js"
export * from "./RequestNOAnnualLeave.vue?vue&type=script&lang=js"

import "./RequestNOAnnualLeave.vue?vue&type=style&index=0&id=6985f84e&lang=scss"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "6985f84e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6985f84e', script)) {
    api.reload('6985f84e', script)
  }
  
  module.hot.accept("./RequestNOAnnualLeave.vue?vue&type=template&id=6985f84e", () => {
    api.rerender('6985f84e', render)
  })

}

script.__file = "src/views/AnnualLeave/RequestNOAnnualLeave.vue"

export default script